import { render } from "./ViewJobVacancy.vue?vue&type=template&id=1b47aea9&scoped=true"
import script from "./ViewJobVacancy.vue?vue&type=script&lang=js"
export * from "./ViewJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=1b47aea9&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b47aea9"]])

export default __exports__